import { ApiEndpoints } from './endpoints';
import { IContactUs, IContactUsDto } from '../interfaces/ContactUs.interface';
import { IApi } from './api.service';

export const createContactUs = async (api: IApi, dto: IContactUsDto): Promise<void> => {
    await api.axiosInstance.post<IContactUs, IContactUsDto>(ApiEndpoints.contactUs, dto);
};
